/**
 * A display component showing key details about the lot being prepped.
 * @param {object} props
 * @param {number} props.totalUnits - Total units available in the lot.
 * @param {number} props.numCases - The original number of cases on the pallet.
 * @param {number} props.unitsPerCase - The original units per case for the item.
 * @param {number} props.numLooseUnits - The original number of loose units on the pallet.
 * @returns {JSX.Element}
 */
function Step1_LotInformation({ totalUnits, numCases, unitsPerCase, numLooseUnits }) {
    return (
        <div className="px-3 py-2 bg-blue-50 rounded-lg">
            <p className="text-xs text-blue-800">Lot Information:</p>
            <p className="text-xs mt-1">
                Total Units in Lot: <span className="font-semibold">{totalUnits}</span>
            </p>
            <p className="text-xs text-blue-700 mt-1">
                ({numCases} cases × {unitsPerCase} units/case) + {numLooseUnits} loose units = {totalUnits} total units
            </p>
            <p className="text-xs text-blue-700 mt-1">
                Note: The sum of (RPCs × Units per RPC) + Loose Units + Scrap Units must not exceed the total units in
                lot.
            </p>
        </div>
    );
}

export default Step1_LotInformation;
